import { HomePageFormData } from 'types/home-page';

export const initialValues: HomePageFormData = {
    description: '',
    attachments: [],
};

export const MAX_FILE_SIZE = 5242880;
